<template>
  <div>
    <div v-for="(str, index) in splitStr(item.clients.state)" :key="index">{{
      str
    }}</div>
  </div>
</template>

<script>
export default {
  name: "order-status-warehouse-state",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
